export default __webpack_public_path__ + "static/media/instr01.0798e38a.svg";